module.exports = __webpack_public_path__ + "media/images/countryrect/bt-e4dbe67aa8ffa880062c54e4b6648bef.svg";